import './JTBDIntro.scss';
import ValuePropositionDivider from "./../../../../ui/illustrations/value-proposition-divider";

const JTBDIntro = () => {
  
  return (
    <section className="JTBDIntro section">
      <div className="wrapper wrapper--large">
        <div className="row">
            <div className="col">
              <img alt="" className='JTBDIntro__illustration' src="/images/jtbdpage/client-thinking.webp" />
            </div>

            <div className="col">
              <h1 className="wrapper__title">Os seus clientes não compram produtos. <br/>Contratam Soluções.</h1>
              <div className="wrapper__subtitle h5">
                <p>Descubra o verdadeiro motivo pelo qual os seus clientes escolhem o seu serviço - e como usar isso a seu favor.</p>
                <p>Vamos descobrir juntos?</p>
              </div>
            </div>

        </div>
      </div>
      <ValuePropositionDivider className="vp__divider" />
    </section>
  );
};

export default JTBDIntro;